import { useContext } from 'react';
import { LocaleContext } from '../context/LocaleContext';

/**
 * Access the translation function for the active language.
 *
 *   const { t } = useTranslation();
 *   t('settings.preferences.languageRegion')      → "Language & region" / "ቋንቋ እና ክልል"
 *   t('dashboard.welcome', { name: 'Alex' })      → "Welcome back, Alex" / "እንኳን ደህና መጡ፣ Alex"
 *
 * Keys missing from the active bundle fall back to English, then to the key.
 */
export function useTranslation() {
  const ctx = useContext(LocaleContext);
  if (!ctx) throw new Error('useTranslation must be used within a <LocaleProvider>');
  return { t: ctx.t, language: ctx.language, setLanguage: ctx.setLanguage };
}
